enum PublicationStatus {
    NOT_PUBLISHED = 'notPublished',
    PUBLISHED = 'published',
    UNLISTED = 'unlisted',
    INTERNAL_ONLY = 'internalOnly',
    UNPUBLISHED = 'unpublished',
}

export default PublicationStatus;
